import { RouteItem } from '@eastcoal/router/types/route'

import { HOUSE_AUCTION_SALE_LIST_PAGE_PATH } from './constants/path'

export const houseAuctionSaleListRoute: RouteItem = {
  title: '竞拍（房屋）',
  path: HOUSE_AUCTION_SALE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
